import { message, Spin } from 'antd';
import { NuqsAdapter } from 'nuqs/adapters/react';
import React, { Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useValidateToken } from './api-hooks/admin';
import './App.css';
import GenericLoader from './views/components/loaders/GenericLoader';
import MainSiteLoader from './views/components/loaders/site-loader';
Spin.setDefaultIndicator(<div><GenericLoader /></div>,);
const LayoutAdmin = React.lazy(() => import('./views/layout/Layout'));
const Login = React.lazy(() => import('./views/pages/Login'));
function App() {

	const { data, isLoading, isFetching, isError, error } = useValidateToken();

	if (isError && error) {
		message.error(error.message);
	}

	return (
		<BrowserRouter basename="/">
			{
				!isLoading
					? !error && !isFetching

						? <Suspense fallback={<MainSiteLoader />}>{
							<NuqsAdapter>
								<LayoutAdmin />
							</NuqsAdapter>
						}</Suspense>
						: <Suspense fallback={<MainSiteLoader />}><Login /></Suspense>
					: <MainSiteLoader />
			}
		</BrowserRouter >
	);
}

export default App;
